<template>
  <a-modal
      class="tips-modal"
      :width="430"
      :visible="isTipsVisible"
      :closable="false"
      :centered="true"
      :cancelButtonProps="{ style: !tipsInfo.showCancel ? { display: 'none' } : {} }"
      @cancel="handleIsTipsClose"
      @ok="handleIsTipsSure"
  >
    <div class="content">
      <div class="title">
        <div class="tips-icon">
          <a-icon
              :type="iconComponent"
              :class="iconClass" />
        </div>
        <span>{{ tipsInfo.title }}</span>
      </div>
      <p class="tips-content">{{ tipsInfo.content }}</p>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'TipsModal',
  data() {
    return {
      isTipsVisible: false,
      tipsInfo: {
        title: '',
        content: '',
        icon: 'info',
        showCancel: true,
        confirmCallback: null,
        cancelCallback: null
      }
    }
  },
  computed: {
    iconComponent() {
      const iconMap = {
        info: 'info-circle',
        warn: 'exclamation-circle',
        error: 'close-circle',
        success: 'check-circle'
      }
      return iconMap[this.tipsInfo.icon]
    },
    iconClass() {
      return `icon-${this.tipsInfo.icon}`
    }
  },
  methods: {
    handleIsTipsClose() {
      this.isTipsVisible = false
      this.tipsInfo.cancelCallback && this.tipsInfo.cancelCallback()
    },
    handleIsTipsSure() {
      this.isTipsVisible = false
      this.tipsInfo.confirmCallback && this.tipsInfo.confirmCallback()
    },
    showModal(options) {
      Object.assign(this.tipsInfo, {
        title: options.title || '',
        content: options.content || '',
        icon: options.icon || 'info',
        showCancel: options.showCancel ?? true,
        confirmCallback: options.confirmCallback,
        cancelCallback: options.cancelCallback
      })
      this.isTipsVisible = true
    }
  }
}
</script>
<style lang="less" scoped>
.tips-modal {
  .content {
    .title {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      width: 100%;
      padding-bottom: 22px;
      overflow: hidden;
      font-size: 16px;
      line-height: 1.5715;
      text-align: left;
      color: #ffffff;
      .tips-icon {
        margin-right: 8px;
        .icon-info /deep/svg{
          color: #165dff;
        }
        .icon-warn /deep/svg{
          color: #ff7d00;
        }
        .icon-error /deep/svg{
          color: #f53f3f;
        }
        .icon-success /deep/svg{
          color: #00b42a;
        }
        .anticon {
          font-size: 16px;
        }
      }
    }
    .tips-content {
      font-size: 14px;
      color: #ffffff;
    }
  }
}
</style>